import localforage from 'localforage';

const increaseOrderCount = async (customerId) => {
  try {
    var customersStore = localforage.createInstance({
      name: 'Customers',
    });

    const customers = await customersStore.getItem('nodes');
    //  const customerRoutes = await customersStore.getItem('customerRoutes');

    const updatedCustomers = customers.map((c) => {
      if (String(c.id) === String(customerId)) {
        return {
          ...c,
          dailyOrderCount: (c.dailyOrderCount || 0) + 1,
        };
      }
      return c;
    });

    /*  const updatedCustomerRoutes = customerRoutes?.map((cr) => {
      const customerObj = cr.customer;

      if (customerObj.id === customerId) {
        customerObj.dailyOrderCount = (customerObj.dailyOrderCount || 0) + 1;
        return {
          ...cr,
          customer: customerObj,
        };
      }
      return cr;
    });
*/
    await customersStore.setItem('nodes', updatedCustomers);
    // await customersStore.setItem('customerRoutes', updatedCustomerRoutes);
  } catch (error) {
    console.error(error);
  }
};

export default increaseOrderCount;
